(function () {
  if (!window.themeGlobalVariables?.settings?.epicQuickShopEnabled) return;

  document.documentElement.classList.add('epic-quick-shop-enabled');

  var cartState = {
    itemsByVariant: new Map(),
    itemCount: 0,
    debounceTimers: new Map()
  };
  var cartMutationQueue = Promise.resolve();
var lastCartMutationAt = 0;
var CART_MUTATION_MIN_GAP = 250;

function wait(ms) {
  return new Promise(function (resolve) {
    window.setTimeout(resolve, ms);
  });
}

function enqueueCartMutation(task) {
  var queuedTask = cartMutationQueue.then(function () {
    var elapsed = Date.now() - lastCartMutationAt;
    var delay = Math.max(CART_MUTATION_MIN_GAP - elapsed, 0);

    return wait(delay).then(function () {
      lastCartMutationAt = Date.now();
      return task();
    });
  });

  cartMutationQueue = queuedTask.catch(function () {
    return null;
  });

  return queuedTask;
}

  function ensureJsEndpoint(url, fallback) {
    var endpoint = url || fallback;

    if (endpoint.indexOf('.js') === -1) {
      endpoint = endpoint + '.js';
    }

    return endpoint;
  }

  function getCartUrl() {
    return ensureJsEndpoint(window.routes?.cart_url, '/cart');
  }

  function getAddUrl() {
    return ensureJsEndpoint(window.routes?.cart_add_url, '/cart/add');
  }

  function getChangeUrl() {
    return ensureJsEndpoint(window.routes?.cart_change_url, '/cart/change');
  }

  function getThemeCart() {
    return document.querySelector('cart-drawer') || document.querySelector('main-cart');
  }

  function getThemeSections() {
    var themeCart = getThemeCart();

    if (themeCart && typeof themeCart.getSectionsToRender === 'function') {
      return themeCart.getSectionsToRender().map(function (section) {
        return section.id || section.section;
      });
    }

    return ['cart-icon-bubble'];
  }

  function getMode() {
    return (
      document.documentElement.getAttribute('data-epic-purchase-mode') ||
      localStorage.getItem('epic_purchase_mode') ||
      'retail'
    );
  }
  function applyWholesaleCardPrices(root) {
  if (getMode() !== 'wholesale') return;

  var scope = root || document;

  /*
   * Precio de mayoreo por producto: viene de data-wholesale-price,
   * que card-product.liquid llena desde el metafield epic.precio_mayoreo
   * (la misma fuente que usa price.liquid). Sin metafield, no se toca.
   */
  var canFormatMoney =
    typeof cartStrings !== 'undefined' &&
    cartStrings.money_format &&
    typeof NextSkyTheme !== 'undefined' &&
    typeof NextSkyTheme.formatMoney === 'function';

  var selector = '[data-epic-quick-shop][data-wholesale-price]';
  var quickShops = [];

  if (scope.matches && scope.matches(selector)) {
    quickShops.push(scope);
  }

  if (scope.querySelectorAll) {
    quickShops = quickShops.concat(
      Array.from(scope.querySelectorAll(selector))
    );
  }

  quickShops.forEach(function (quickShop) {
    var wholesaleCents = parseInt(quickShop.getAttribute('data-wholesale-price'), 10);
    if (!(wholesaleCents > 0)) return;

    var wholesalePrice = canFormatMoney
      ? NextSkyTheme.formatMoney(wholesaleCents, cartStrings.money_format)
      : '$ ' + (wholesaleCents / 100).toFixed(2);

    var productItem = quickShop.closest('.product-item');
    if (!productItem) return;

    var priceWrapper = productItem.querySelector('.card-product-price');
    if (!priceWrapper) return;

    var regularPrice = document.createElement('div');
    regularPrice.className = 'price-regular';
    regularPrice.setAttribute('dir', 'auto');

    var price = document.createElement('span');
    price.className = 'price heading-color';
    price.textContent = wholesalePrice;

    regularPrice.appendChild(price);
    priceWrapper.replaceChildren(regularPrice);
  });
}

  function getCards() {
    return Array.from(document.querySelectorAll('[data-epic-quick-shop]'));
  }

  function getVariantId(card) {
    return Number(card?.dataset?.variantId || 0);
  }

  function getMaxQuantity(card) {
  var inventoryManaged = card.dataset.inventoryManaged === 'true';
  var inventoryQuantity = Number(card.dataset.inventoryQuantity || 0);

  if (inventoryManaged) {
    return Math.max(inventoryQuantity, 0);
  }

  return 999;
}

  function getCartItemForCard(card) {
    var variantId = getVariantId(card);
    return cartState.itemsByVariant.get(variantId) || null;
  }

  function getQuantityValueElement(card) {
  return card.querySelector('[data-epic-qty-value]');
}

function readQuantityValue(card) {
  var qtyValue = getQuantityValueElement(card);
  if (!qtyValue) return 1;

  var value = qtyValue.tagName === 'INPUT' ? qtyValue.value : qtyValue.textContent;
  var quantity = parseInt(value, 10);

  return Number.isFinite(quantity) ? quantity : 1;
}

function setQuantityText(card, quantity) {
  var qtyValue = getQuantityValueElement(card);
  if (!qtyValue) return;

  quantity = quantity > 0 ? quantity : 1;

  if (qtyValue.tagName === 'INPUT') {
    qtyValue.value = quantity;
  } else {
    qtyValue.textContent = quantity;
  }
}

  function setAddedText(card, isAdded) {
    var addText = card.querySelector('[data-epic-add-text]');
    if (!addText) return;

    addText.textContent = isAdded ? '✓ Agregado' : 'Agregar al carrito';
  }

  function setAdding(card, isAdding) {
    card.classList.toggle('epic-quick-shop--loading', Boolean(isAdding));

    var addButtons = card.querySelectorAll('[data-epic-add], [data-epic-mobile-add]');
    addButtons.forEach(function (button) {
      button.disabled = Boolean(isAdding);
    });
  }

  function setSyncing(card, isSyncing) {
    card.classList.toggle('epic-quick-shop--syncing', Boolean(isSyncing));
  }

  function setCardActive(card, quantity) {
    var productCard = card.closest('.product-item');
    var isActive = quantity > 0;

    card.classList.toggle('epic-quick-shop--in-cart', isActive);

    if (productCard) {
      productCard.classList.toggle('epic-quick-shop--active', isActive);
    }

    setQuantityText(card, quantity);
    setAddedText(card, isActive);
  }

  function rebuildCartState(cart) {
    cartState.itemsByVariant.clear();
    cartState.itemCount = Number(cart?.item_count || 0);

    (cart?.items || []).forEach(function (item) {
      var variantId = Number(item.variant_id || item.id || 0);
      if (!variantId) return;

      var existing = cartState.itemsByVariant.get(variantId);

      if (existing) {
        existing.quantity += Number(item.quantity || 0);

        if (item.key) {
          existing.keys.push(item.key);
        }
      } else {
        cartState.itemsByVariant.set(variantId, {
          variantId: variantId,
          quantity: Number(item.quantity || 0),
          key: item.key,
          keys: item.key ? [item.key] : []
        });
      }
    });
  }
  function applyAddedItemsToCartState(data) {
  var addedItems = [];

  if (Array.isArray(data?.items)) {
    addedItems = data.items;
  } else if (data && (data.variant_id || data.id)) {
    addedItems = [data];
  }

  addedItems.forEach(function (item) {
    var variantId = Number(item.variant_id || item.id || 0);
    var addedQuantity = Number(item.quantity || 0);

    if (!variantId || addedQuantity <= 0) return;

    var existing = cartState.itemsByVariant.get(variantId);

    if (existing) {
      existing.quantity += addedQuantity;

      if (item.key && !existing.keys.includes(item.key)) {
        existing.keys.push(item.key);
      }

      if (!existing.key && item.key) {
        existing.key = item.key;
      }
    } else {
      cartState.itemsByVariant.set(variantId, {
        variantId: variantId,
        quantity: addedQuantity,
        key: item.key,
        keys: item.key ? [item.key] : []
      });
    }

    cartState.itemCount += addedQuantity;
  });

  updateCartCount({
    item_count: cartState.itemCount
  });

  syncCardsFromCart();
}

  function updateCartCount(cart) {
    var count = Number(cart?.item_count || cartState.itemCount || 0);
    cartState.itemCount = count;

    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.setAttribute('data-cart-count', String(count));
      element.textContent = String(count);
    });

    document.querySelectorAll('.cart-count').forEach(function (element) {
      element.textContent = String(count);
    });
  }

  function syncCardsFromCart() {
    getCards().forEach(function (card) {
      var item = getCartItemForCard(card);
      var quantity = item ? Number(item.quantity || 0) : 0;

      setCardActive(card, quantity);
    });
  }

  function updateThemeCartFromSections(sections) {
    if (!sections) return;

    var parser = new DOMParser();

    Object.keys(sections).forEach(function (sectionId) {
      var html = sections[sectionId];
      if (!html) return;

      var parsed = parser.parseFromString(html, 'text/html');

      if (sectionId === 'cart-icon-bubble') {
        var currentDesktop = document.getElementById('cart-icon-bubble');
        var incomingDesktop = parsed.getElementById('cart-icon-bubble');

        if (currentDesktop && incomingDesktop) {
          currentDesktop.innerHTML = incomingDesktop.innerHTML;
        }

        var currentMobile = document.getElementById('cart-icon-bubble-mobile');
        var incomingMobile = parsed.getElementById('cart-icon-bubble-mobile');

        if (currentMobile && incomingMobile) {
          currentMobile.innerHTML = incomingMobile.innerHTML;
        }

        return;
      }

      var themeCart = getThemeCart();

      if (themeCart && themeCart.sectionId && sectionId === themeCart.sectionId) {
        var incomingDrawerBody = parsed.querySelector('.drawer__body');
        var currentDrawerBody = themeCart.querySelector('.drawer__body');

        if (incomingDrawerBody && currentDrawerBody) {
          currentDrawerBody.innerHTML = incomingDrawerBody.innerHTML;
        }

        var incomingDrawerFooter = parsed.querySelector('.drawer__footer-bottom-total');
        var currentDrawerFooter = themeCart.querySelector('.drawer__footer-bottom-total');

        if (incomingDrawerFooter && currentDrawerFooter) {
          currentDrawerFooter.innerHTML = incomingDrawerFooter.innerHTML;
        }

        var incomingCartForm = parsed.querySelector('.cart-drawer__form');
        var currentCartForm = themeCart.querySelector('.cart-drawer__form');

        if (incomingCartForm && currentCartForm) {
          currentCartForm.innerHTML = incomingCartForm.innerHTML;
        }

        var incomingHeader = parsed.querySelector('.drawer__header-cart');
        var currentHeader = themeCart.querySelector('.drawer__header-cart');

        if (incomingHeader && currentHeader) {
          currentHeader.innerHTML = incomingHeader.innerHTML;
        }
      }
    });
  }
function readJsonResponse(response, fallbackMessage) {
  return response.text().then(function (text) {
    var data = {};

    if (text) {
      try {
        data = JSON.parse(text);
      } catch (error) {
        var invalidResponseError = new Error(
          response.status === 429
            ? 'Shopify recibió demasiadas solicitudes. Espera un momento e intenta nuevamente.'
            : fallbackMessage || 'El servidor devolvió una respuesta inválida.'
        );

        invalidResponseError.status = response.status;
        throw invalidResponseError;
      }
    }

    if (!response.ok || data.status || data.errors) {
      var message =
        data.description ||
        data.message ||
        data.errors ||
        fallbackMessage ||
        'La solicitud no pudo completarse.';

      var requestError = new Error(
        response.status === 429
          ? 'Shopify recibió demasiadas solicitudes. Espera un momento e intenta nuevamente.'
          : String(message)
      );

      requestError.status = response.status;
      requestError.data = data;

      throw requestError;
    }

    return data;
  });
}
  function fetchCart() {
    return fetch(getCartUrl(), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('No se pudo leer el carrito');
        }

        return response.json();
      })
      .then(function (cart) {
        rebuildCartState(cart);
        updateCartCount(cart);
        syncCardsFromCart();
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function showNotice(message) {
    var existing = document.querySelector('[data-epic-quick-shop-notice]');
    if (existing) existing.remove();

    var notice = document.createElement('div');
    notice.className = 'epic-quick-shop-notice';
    notice.setAttribute('data-epic-quick-shop-notice', '');

    var text = document.createElement('span');
    text.className = 'epic-quick-shop-notice__text';
    text.textContent = message || 'Agregado al carrito';

    notice.appendChild(text);
    document.body.appendChild(notice);

    window.setTimeout(function () {
      notice.classList.add('is-visible');
    }, 20);

    window.setTimeout(function () {
      notice.classList.remove('is-visible');

      window.setTimeout(function () {
        notice.remove();
      }, 220);
    }, 2300);
  }
  function isStockAvailabilityMessage(message) {
  message = String(message || '').toLowerCase();

  return (
    message.includes('disponibilidad') ||
    message.includes('disponible') ||
    message.includes('existencia') ||
    message.includes('inventario') ||
    message.includes('available') ||
    message.includes('availability') ||
    message.includes('inventory') ||
    message.includes('stock')
  );
}

function getStockAdjustedMessage(max) {
  if (max && Number(max) > 0) {
    return 'Solo hay ' + max + ' disponibles. Cantidad ajustada.';
  }

  return 'Cantidad ajustada al stock disponible.';
}

function normalizeQuantityForStock(card, quantity, options) {
  var max = getMaxQuantity(card);
  var originalQuantity = Number(quantity || 1);
  var finalQuantity = originalQuantity;

  if (!Number.isFinite(finalQuantity) || finalQuantity < 1) {
    finalQuantity = 1;
  }

  if (max <= 0) {
    finalQuantity = 0;
  } else if (finalQuantity > max) {
    finalQuantity = max;

    if (options?.showNotice) {
      showNotice(getStockAdjustedMessage(max));
    }
  }

  return finalQuantity;
}

  function getQuantityToAdd(card) {
  var quantity = readQuantityValue(card);
  var max = getMaxQuantity(card);

  return Math.max(1, Math.min(quantity, max || 1));
}

  function addToCart(card, quantity, options) {
    var variantId = getVariantId(card);
    var max = getMaxQuantity(card);

    if (!variantId) return Promise.resolve();

    if (max <= 0) {
      showNotice('Producto agotado');
      return Promise.resolve();
    }

    quantity = normalizeQuantityForStock(card, quantity, { showNotice: true });

if (quantity <= 0) {
  showNotice('Producto agotado');
  return Promise.resolve();
}

    setAdding(card, true);

    var body = {
      items: [
        {
          id: variantId,
          quantity: quantity
        }
      ],
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    if (getMode() === 'wholesale') {
      body.items[0].properties = {
        _epic_purchase_mode: 'wholesale'
      };
    }

    return enqueueCartMutation(function () {
  return fetch(getAddUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(body)
  }).then(function (response) {
    return readJsonResponse(response, 'No se pudo agregar al carrito');
  });
})
.then(function (data) {
  updateThemeCartFromSections(data.sections);

  applyAddedItemsToCartState(data);

  return data;
})
.then(function () {
        var item = getCartItemForCard(card);
        var finalQuantity = item ? item.quantity : quantity;

        setCardActive(card, finalQuantity);

        if (options?.showNotice) {
          showNotice('Producto agregado al carrito');
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('nextsky:cart:added'));
        document.dispatchEvent(new CustomEvent('epic:cart-drawer-stale'));
      })
      .catch(function (error) {
  var message = error.message || 'No se pudo agregar';
  var max = getMaxQuantity(card);

  console.error('[Epic Quick Shop] Error al agregar:', error);

  if (isStockAvailabilityMessage(message)) {
    showNotice(getStockAdjustedMessage(max));
  } else {
    showNotice(message);
  }
})
      .finally(function () {
        setAdding(card, false);
      });
  }

  function changeCartQuantity(card, quantity) {
    var variantId = getVariantId(card);
    var item = getCartItemForCard(card);
    var max = getMaxQuantity(card);

    if (!variantId) return Promise.resolve();

    quantity = Math.max(0, Number(quantity || 0));

if (quantity > 0) {
  quantity = normalizeQuantityForStock(card, quantity, { showNotice: true });
}

if (quantity < 0) {
  quantity = 0;
}

    var cartLineId = item?.key || String(variantId);

    setSyncing(card, true);

   return enqueueCartMutation(function () {
  return fetch(getChangeUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: cartLineId,
      quantity: quantity,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  }).then(function (response) {
    return readJsonResponse(response, 'No se pudo actualizar');
  });
})
      .then(function (cart) {
        updateThemeCartFromSections(cart.sections);
        rebuildCartState(cart);
        updateCartCount(cart);
        syncCardsFromCart();

        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('epic:cart-drawer-stale'));
      })
      .catch(function (error) {
  var message = error.message || 'No se pudo actualizar';
  var max = getMaxQuantity(card);

  console.error('[Epic Quick Shop] Error al actualizar:', error);

  if (isStockAvailabilityMessage(message)) {
    showNotice(getStockAdjustedMessage(max));
  } else {
    showNotice(message);
  }
})
      .finally(function () {
        setSyncing(card, false);
      });
  }

  function scheduleQuantityChange(card, quantity) {
    var variantId = getVariantId(card);
    if (!variantId) return;

    if (cartState.debounceTimers.has(variantId)) {
      clearTimeout(cartState.debounceTimers.get(variantId));
    }

    var timer = window.setTimeout(function () {
      cartState.debounceTimers.delete(variantId);
      changeCartQuantity(card, quantity);
    }, 650);

    cartState.debounceTimers.set(variantId, timer);
  }

  function handleQuantityButton(card, direction) {
    var item = getCartItemForCard(card);
    var isInCart = Boolean(item);
    var max = getMaxQuantity(card);
    var currentQuantity = readQuantityValue(card);
    var nextQuantity = currentQuantity + direction;

    if (!isInCart) {
      nextQuantity = Math.max(1, Math.min(nextQuantity, max || 1));
      setQuantityText(card, nextQuantity);
      return;
    }

    nextQuantity = Math.max(0, Math.min(nextQuantity, max || currentQuantity));

    if (max > 0 && nextQuantity >= max && direction > 0 && currentQuantity >= max) {
      showNotice('Máximo disponible');
      return;
    }

    setCardActive(card, nextQuantity);

    if (nextQuantity === 0) {
      showNotice('Producto eliminado');
    }

    scheduleQuantityChange(card, nextQuantity);
  }
function normalizeManualQuantity(card, options) {
  var item = getCartItemForCard(card);
  var isInCart = Boolean(item);
  var max = getMaxQuantity(card);
  var rawQuantity = readQuantityValue(card);
  var nextQuantity = rawQuantity;

  if (!Number.isFinite(nextQuantity) || nextQuantity < 1) {
    nextQuantity = 1;
  }

  if (max <= 0) {
    nextQuantity = 1;
  }

  if (max > 0 && nextQuantity > max) {
    nextQuantity = max;

    if (options?.showStockNotice) {
      showNotice(getStockAdjustedMessage(max));
    }
  }

  setQuantityText(card, nextQuantity);

  if (isInCart) {
    setCardActive(card, nextQuantity);
    scheduleQuantityChange(card, nextQuantity);
  }

  return nextQuantity;
}

function handleQuantityInputFocus(input) {
  window.setTimeout(function () {
    input.select();
  }, 0);
}

function handleQuantityInputKeydown(event, card) {
  if (event.key === 'Enter') {
    event.preventDefault();
    event.stopPropagation();

    normalizeManualQuantity(card, { showStockNotice: true });

    if (event.target.blur) {
      event.target.blur();
    }
  }
}

function handleQuantityInputChange(card) {
  normalizeManualQuantity(card, { showStockNotice: true });
}
  document.addEventListener('click', function (event) {
    var plus = event.target.closest('[data-epic-qty-plus]');
    var minus = event.target.closest('[data-epic-qty-minus]');
    var add = event.target.closest('[data-epic-add]');
    var mobileAdd = event.target.closest('[data-epic-mobile-add]');

    if (!plus && !minus && !add && !mobileAdd) return;

    var card = event.target.closest('[data-epic-quick-shop]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    if (plus) {
      handleQuantityButton(card, 1);
      return;
    }

    if (minus) {
      handleQuantityButton(card, -1);
      return;
    }

    if (mobileAdd) {
      addToCart(card, 1, { showNotice: true });
      return;
    }

    if (add) {
      var item = getCartItemForCard(card);

      if (item) return;

      addToCart(card, getQuantityToAdd(card), { showNotice: false });
    }
  });
document.addEventListener('focusin', function (event) {
  var input = event.target.closest('[data-epic-qty-value]');
  if (!input || input.tagName !== 'INPUT') return;

  handleQuantityInputFocus(input);
});

document.addEventListener('keydown', function (event) {
  var input = event.target.closest('[data-epic-qty-value]');
  if (!input || input.tagName !== 'INPUT') return;

  var card = event.target.closest('[data-epic-quick-shop]');
  if (!card) return;

  handleQuantityInputKeydown(event, card);
});

document.addEventListener('change', function (event) {
  var input = event.target.closest('[data-epic-qty-value]');
  if (!input || input.tagName !== 'INPUT') return;

  var card = event.target.closest('[data-epic-quick-shop]');
  if (!card) return;

  handleQuantityInputChange(card);
});

document.addEventListener('blur', function (event) {
  var input = event.target.closest('[data-epic-qty-value]');
  if (!input || input.tagName !== 'INPUT') return;

  var card = event.target.closest('[data-epic-quick-shop]');
  if (!card) return;

  handleQuantityInputChange(card);
}, true);
  if (getMode() === 'wholesale') {
  applyWholesaleCardPrices(document);

  var wholesalePriceObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        applyWholesaleCardPrices(node);
      });
    });
  });

  wholesalePriceObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

fetchCart();
})();